import React from 'react';
import {useTranslation} from 'react-i18next';

// Keeps the plain `translate()` helper reactive: re-renders the whole tree when
// the language changes or when an on-demand namespace finishes loading, so the
// tree recomputes its translate() calls. Components wrapped in React.memo are
// the only exception.
const I18nSubscriber = ({children}) => {
  const {i18n} = useTranslation();
  const [, forceUpdate] = React.useReducer((n) => n + 1, 0);

  React.useEffect(() => {
    const handler = () => forceUpdate();
    i18n.on('loaded', handler);
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('loaded', handler);
      i18n.off('languageChanged', handler);
    };
  }, [i18n]);

  return React.cloneElement(children, {i18nLanguage: i18n.resolvedLanguage});
};

export default I18nSubscriber;
